import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownContainer, {
  DropdownContainerHeader
} from "../../../../../../../components/dropdown/DropdownContainer";
import GridExportScopeOptions from "../../../../../../../components/gridexportmenu/GridExportScopeOptions";
import useExportScope from "../../../../../../../components/gridexportmenu/hooks/useExportScope";
import { exportScopeValues } from "../../../../../../../components/gridexportmenu/const";
import { copyToClipboard } from "../../../../../../../utils";
import api from "../../../../../api";
import { TYPE_TO_DISPLAY } from "../consts";
import { IocRow } from "../@types/LLMSummary";

type LLMIocExportDropdownProps = {
  data: IocRow[];
  selectedRows: Record<string, unknown>;
};

const LLMIocExportDropdown = ({
  data,
  selectedRows
}: LLMIocExportDropdownProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const hasSelectedRows = Object.keys(selectedRows).length > 0;
  const { exportScope, setExportScope } = useExportScope(hasSelectedRows);

  const getIOCData = (): Array<IocRow> => {
    const selectedSamplesActive =
      hasSelectedRows && exportScope === exportScopeValues.SELECTED;

    const items = selectedSamplesActive
      ? (Object.values(selectedRows) as IocRow[])
      : data;

    return items.map(item => ({
      ...item,
      type: TYPE_TO_DISPLAY[item.type] ?? item.type
    }));
  };

  const handleExport = (format: string) => {
    const iocData = getIOCData();
    api.exportLLMIOC({ format, data: iocData });
    setShowMenu(false);
  };

  const handleCopy = () => {
    const iocData = getIOCData();
    const iocValues = iocData.map(item => item.name).join("\n");
    const notificationText = `IOC${iocData.length > 1 ? "s" : ""}`;
    copyToClipboard(iocValues, notificationText);
    setShowMenu(false);
  };

  return (
    <DropdownContainer
      name="llm-ioc-export"
      autoClose="outside"
      buttonLabel="Export"
      buttonIcon="export-data"
      show={showMenu}
      onToggle={() => setShowMenu(!showMenu)}
    >
      <>
        <DropdownContainerHeader>
          <GridExportScopeOptions
            useScope
            showScopeNote={false}
            selectedScope={exportScope}
            setSelectedScope={setExportScope}
            hasSelectedRows={hasSelectedRows}
            scopeLabels={{
              page: "All IOCs",
              selected: "Selected IOCs"
            }}
          />
        </DropdownContainerHeader>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => handleCopy()} data-testid="llm_ioc_copy">
          Copy IOCs
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={() => handleExport("csv")}
          data-testid="llm_ioc_export_csv"
        >
          Export CSV
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => handleExport("json")}
          data-testid="llm_ioc_export_json"
        >
          Export JSON
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => handleExport("xml")}
          data-testid="llm_ioc_export_xml"
        >
          Export XML
        </Dropdown.Item>
      </>
    </DropdownContainer>
  );
};

export default LLMIocExportDropdown;
